module.exports = __webpack_public_path__ + "img/icon.23007132.jpg";